import { render, staticRenderFns } from "./TestCentreCwqs.vue?vue&type=template&id=77f0b038"
import script from "./TestCentreCwqs.vue?vue&type=script&lang=js"
export * from "./TestCentreCwqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports